<template>
  <section class="redes">
    <p class="sci-redes-title">Redes temáticas</p>
    <div class="sci-redes-dot">.</div>

    <div class="sci-redes-content">
      <table class="sci-redes-table">
        <thead class="sci-redes-thead">
          <tr class="sci-redes-tr1">
            <td class="sci-redes-tr1-1">Nombre</td>
            <td class="sci-redes-tr1-1">Descripción</td>
          </tr>
        </thead>
        <tbody class="sci-redes-tbody">
          <tr class="sci-redes-tr2" v-for="(red, index) in redes.data" :key="index">
            <td class="sci-redes-tr2-1">{{ red ? red.nombre : "No tiene nombre" }}</td>
            <td class="sci-redes-tr2-1">{{ red ? red.descripcion : "No tiene descripción" }}</td>
          </tr>
        </tbody>
        <v-spacer></v-spacer>
        <div class="pagination justify-content-center">
          <pagination :limit="vPaginator.limit" :data="this.redes" @pagination-change-page="getRedesTematicas"></pagination>
        </div>
      </table>
    </div>
  </section>
</template>

<script>
import axios from 'axios';

export default {
  props: ["urlApi"],
  name: 'redes_tematicas',
  data(){
    return{
      redes:{
        current_page: 1,
        data:[]
      },
      vPaginator: {
        limit: 10
      },
    }
  },
  created(){
		this.getRedesTematicas();
  },
  methods:{
		getRedesTematicas: function(page = 1){
			var url = process.env.VUE_APP_API_URL + `/api/redes?page=${page}`;
			axios
			.get(url)
			.then(response => { this.redes = response.data})
			.catch(error => errorHandling(error));
		},
  },
}
</script>

<style>
  .redes{
		margin-bottom: 2%;
	}
  .sci-redes-title{
		margin: 3% auto 0%;
		text-transform: uppercase;
		color: rgba(255,196,0,.9);
		font-weight: bold;
		font-size: 1.5em;
	}
  .sci-redes-dot{
		font-weight: bold;
		color: rgba(0,152,255,.9)
	}
	.sci-redes-dot:before{
		content:'';
		display: inline-block;
		width: 90px;
		height: 1px;
		background: rgba(0,0,0,0.5);
		margin-right: 1.2%;
		border-radius: 1px 1px;
	}
	.sci-redes-dot:after{
		content:'';
		display: inline-block;
		width: 90px;
		height: 1px;
		background: rgba(0,0,0,0.5);
		margin-left: 1.2%;
		border-radius: 0 0 0 0;
	}
  .sci-redes-content{
    width: 85%;
		display: grid;
		grid-template-areas: "sci-redes-table";
		grid-template-columns: 1fr;
		margin: 100px auto;
	}
  .sci-redes-table{
		display: grid;
		grid-area: sci-redes-table;
		border-spacing: 0;
		margin: 0 auto;
		width: 90%;
		align-content: start;
		border-radius: 10px 10px 10px 10px;
		-moz-border-radius: 10px 10px 10px 10px;
		-webkit-border-radius: 10px 10px 10px 10px;
		border: 1px solid #aaa;

	}
	.sci-redes-thead{
		background: rgba(0,0,0,.2);
		color: #000;
		text-align: left;
		padding: 15px;
		border-radius: 10px 10px 10px 10px;
		-moz-border-radius: 10px 10px 10px 10px;																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																														
		-webkit-border-radius: 10px 10px 10px 10px;
	}
  .sci-redes-tr1{
    display: grid;
    grid-template-columns: 1fr 3fr;
  }
  .sci-redes-tbody{
		text-align: left;
		padding: 15px;
	}
	.sci-redes-tr2{
		display: grid;
		grid-template-columns: 1fr 3fr;
	}
	.sci-redes-tr2 td {
		padding: 10px;
	}
  .sci-redes-tr2-2{
		margin: auto 10px;
	}
</style>